import { memo } from 'react';
import { TablePagination as TablePaginationMaterial } from '@mui/material';

interface TablePaginationProps {
  count: number;
  rowsPerPage?: number;
  page: number;
  onPageChange: (value: number) => void;
  onRowsPerPageChange: (value: number) => void;
  rowsPerPageOptions?: Array<number>;
}

const TablePaginationComponent = ({
  count,
  rowsPerPage,
  page,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = [5, 10, 25],
}: TablePaginationProps) => {
  return (
    <TablePaginationMaterial
      rowsPerPageOptions={rowsPerPageOptions}
      component="div"
      labelRowsPerPage="Righe per pagina:"
      count={count || 0}
      rowsPerPage={rowsPerPage || 10}
      page={page || 0}
      onPageChange={(event: unknown, newPage: number) => onPageChange(newPage)}
      onRowsPerPageChange={(event) => {
        onRowsPerPageChange(parseInt(event.target.value, 10) || 0);
      }}
    />
  );
};

TablePaginationComponent.displayName = 'Table pagination';

const TablePagination = memo(TablePaginationComponent);

export default TablePagination as typeof TablePaginationComponent;
